import { Request } from 'api';
import { AxiosResponse } from 'axios';
import { Link } from 'utils';

type ReturnType = Promise<AxiosResponse<Array<Link>>>;

const getLinks = (id: string): ReturnType => {
    return Request.get(`/links/session/${id}`);
};

export default getLinks;
